import React from "react";
import styles from "./Footer.module.css";

const Footer = React.memo(function ({ className = "" }) {
  const clickedYoutube = () => {
    window.location.href =
      "https://www.youtube.com/channel/UCVAOClMdU9AooxNRN7Vb_LA";
  };
  const clickedInsta = () => {
    window.location.href = "https://www.instagram.com/good_miyorning/";
  };
  return (
    <div className={`${styles.footer} ${className}`}>
      <div className={styles.snsLinkIcon}>
        <div className={styles.instagramArea} onClick={clickedInsta}>
          <div className={styles.instagramIcon} />
        </div>
        <div className={styles.youtubeArea} onClick={clickedYoutube}>
          <div className={styles.youtubeIcon} />
        </div>
      </div>
      <div className={styles.copyrightArea}>
        <span className={styles.allRightsReserved}>
          All rights reserved to © good_miyorning
        </span>
      </div>
    </div>
  );
});

export default Footer;
